<template>
  <div style="display: contents;">
    <meal
      v-for="(meal,mealIndex) in meals"
      :key="'m' + mealIndex"
      :meal="meal"
      :category="category"
      :collapsed="collapsed"
      :showCollapse="showCollapse && (mealIndex === 0) && (category.meals.length > 1)"
      :showBook="showBook"
      :showCategoryName="mealIndex === 0"
      :currency="currency"
      :fees="fees"
      :starRating="starRating"
      :noRooms="noRooms"
      :transport="transport"
      @priceDetails="$emit('priceDetails', {meal: meal})"
      @mealToggle="collapsed = !collapsed"
      @book="$emit('book',{ mealIndex })"
      ></meal>
  </div>
</template>

<script>
import meal from './meal_result'

export default {
  props: {
    category: {
      type: Object,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    starRating: {
      type: Number,
      default: 0
    },
    showCollapse: {
      type: Boolean,
      required: false,
      default: true
    },
    showBook: {
      type: Boolean,
      required: false,
      default: true
    },
    fees: {
      type: Object,
      required: false,
      default: () => { return {} }
    },
    transport: {
      type: String
    },
    noRooms: {
      type: Number,
      default: 1
    }
  },
  components: { meal },
  data () {
    return {
      collapsed: false
    }
  },
  computed: {
    meals () {
      return (this.collapsed || !this.showCollapse) ? this.category.meals : this.category.meals.slice(0, 1)
    }
  }
}
</script>
